// stores/bondLadderStore.js
import { create } from "zustand";

export const useBondLadderStore = create((set, get) => ({
  bondLadderData: {
    side: "BUY",
    account: "",
    bondType: "Corporates",
    comments: "",
    nameOfTheLadder: "",
    numberOfRungs: "",
    qty: "",
    amountPerRung: "",
    totalMaturity: "",
    durationComparison: "",
    duration: "",
    couponMin: "",
    couponMax: "",
    maturityMin: "",
    maturityMax: "",
    minimumRating: "",
    zeroCoupon: "",
    callable: "",
    state: "",
    underlyingRating: "",
    insured: "",
    taxable: "",
    paymentFrequency: "",
    incomeSource: "",
    altMinTax: "",
    securityCharge: ["ALL"],
    sector: "",
    nextCallDate: "",
    priceMin: "",
    priceMax: "",
    yieldMin: "",
    yieldMax: "",
    bondLadderId: null,
    issuer: '',
  },
  expanded: {},
  checked: {},
  fieldErrors: {},
  validationErrors: {},
  accountIdentifiers: [],

  setBondLadderData: (data) =>
    set((state) => ({
      bondLadderData: { ...state.bondLadderData, ...data },
    })),
  
  setExpanded: (panel, isExpanded) =>
    set((state) => ({
      expanded: { ...state.expanded, [panel]: isExpanded },
    })),
  
  setChecked: (panel, field, isChecked) =>
    set((state) => ({
      checked: {
        ...state.checked,
        [panel]: { ...state.checked[panel], [field]: isChecked },
      },
    })),
  
  setFieldErrors: (errors) => set({ fieldErrors: errors }),
  clearFieldErrors: () => set({ fieldErrors: {} }),
  clearFieldError: (fieldName) => set(state => ({
    fieldErrors: {
      ...state.fieldErrors,
      [fieldName]: false
    }
  })),
  setValidationErrors: (errors) => set({ validationErrors: errors }),
  clearValidationErrors: () => set({ validationErrors: {} }),
  setValidationError: (fieldName, hasError) => set(state => ({
    validationErrors: {
      ...state.validationErrors,
      [fieldName]: hasError
    }
  })),
  
  removeFilter: (field) =>
    set((state) => {
      const newData = { ...state.bondLadderData };
      if (field === "couponRange") {
        newData.couponMin = "";
        newData.couponMax = "";
      } else if (field === "maturityRanges") {
        newData.maturityMin = "";
        newData.maturityMax = "";
      } else if (field === "price") {
        newData.priceMin = "";
        newData.priceMax = "";
      } else if (field === "yield") {
        newData.yieldMin = "";
        newData.yieldMax = "";
      } else if (field === "securityCharge") {
        newData.securityCharge = [];
      } else {
        newData[field] = "";
      }
      return { bondLadderData: newData };
    }),
  
  resetBondLadderData: () =>
    set({
      bondLadderData: {
        side: "BUY",
        account: "",
        bondType: "Corporates",
        comments: "",
        nameOfTheLadder: "",
        numberOfRungs: "",
        qty: "",
        amountPerRung: "",
        totalMaturity: "",
        duration: "",
        couponMin: "",
        couponMax: "",
        maturityMin: "",
        maturityMax: "",
        minimumRating: "",
        zeroCoupon: "",
        callable: "",
        state: "",
        underlyingRating: "",
        insured: "",
        taxable: "",
        paymentFrequency: "",
        incomeSource: "",
        altMinTax: "",
        securityCharge: ["ALL"],
        sector: "",
        nextCallDate: "",
        priceMin: "",
        priceMax: "",
        yieldMin: "",
        yieldMax: "",
        issuer: '',
      },
      fieldErrors: {
        account: false,
        bondType: false,
        qty: false,
        side: false,
        nameOfTheLadder: false,
        numberOfRungs: false,
        amountPerRung: false,
        totalMaturity: false,
        bondLadderId: null,

      },
      validationErrors: {},
      expanded: {},
      checked: {},
      accountIdentifiers: [],
    }),

  fetchAccounts: async (token) => {
    try {
      const { fetchAccounts } = await import('../http/api');
      const pmAccountsData = await fetchAccounts(token);
      const accountIdentifiers = pmAccountsData.map(acc => acc.accountIdentifier);
      set({ accountIdentifiers });
      
      const currentData = get().bondLadderData;
      if (accountIdentifiers.length > 0 && !currentData.account) {
        get().setBondLadderData({ account: accountIdentifiers[0] });
        get().clearFieldError('account');
      }
    } catch (error) {
      console.error('Error fetching accounts:', error);
      set({ accountIdentifiers: [] });
    }
  },
}));
